import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { JSONCode, XMLViewer, MarkdownRenderer } from '@vertesia/ui/widgets';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from "react";
import { useMagicPdfContext } from "./MagicPdfProvider";
function LoadingSpinner({ className }) {
    return (_jsx("div", { className: `flex items-center justify-center ${className || ''}`, children: _jsx(Loader2, { className: "w-6 h-6 animate-spin text-gray-400" }) }));
}
export function ExtractedContentView({ viewType, pageNumber }) {
    switch (viewType) {
        case "json":
            return _jsx(JsonPageLayoutView, { pageNumber: pageNumber });
        case "markdown":
            return _jsx(MarkdownPageView, { pageNumber: pageNumber });
        default:
            return _jsx(XmlPageView, { pageNumber: pageNumber });
    }
}
function XmlPageView({ pageNumber }) {
    const { xmlPages: pages } = useMagicPdfContext();
    return (_jsx("div", { className: "px-4 py-2", children: _jsx(XMLViewer, { xml: pages[pageNumber - 1], collapsible: true }) }));
}
function JsonPageLayoutView({ pageNumber }) {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { layoutProvider } = useMagicPdfContext();
    useEffect(() => {
        setLoading(true);
        setError(null);
        layoutProvider.getPageLayout(pageNumber)
            .then((layoutContent) => {
            setContent(layoutContent ? JSON.parse(layoutContent) : null);
            setLoading(false);
        })
            .catch((err) => {
            console.error(err);
            setError(err.message || 'Failed to load layout');
            setLoading(false);
        });
    }, [pageNumber, layoutProvider]);
    if (loading) {
        return (_jsx("div", { className: "px-4 py-8", children: _jsx(LoadingSpinner, {}) }));
    }
    if (error) {
        return (_jsx("div", { className: "px-4 py-2 text-red-500 text-sm", children: error }));
    }
    return content ? _jsx(JSONCode, { className: "w-full", data: content }) : null;
}
function MarkdownPageView({ pageNumber }) {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { markdownProvider } = useMagicPdfContext();
    useEffect(() => {
        setLoading(true);
        setError(null);
        markdownProvider.getPageMarkdown(pageNumber)
            .then((md) => {
            setContent(md);
            setLoading(false);
        })
            .catch((err) => {
            console.error(err);
            setError(err.message || 'Failed to load markdown');
            setLoading(false);
        });
    }, [pageNumber, markdownProvider]);
    if (loading) {
        return (_jsxs("div", { className: "h-full flex flex-col items-center justify-center gap-2", children: [_jsx(LoadingSpinner, {}), _jsx("span", { className: "text-sm text-muted-foreground", children: "Loading..." })] }));
    }
    if (error) {
        return (_jsx("div", { className: "px-4 py-2 text-red-500 text-sm", children: error }));
    }
    return (_jsx("div", { className: "px-4 py-2 prose prose-sm max-w-none dark:prose-invert", children: content ? _jsx(MarkdownRenderer, { children: content }) : _jsx("div", { children: "No markdown content available" }) }));
}
//# sourceMappingURL=ExtractedContentView.js.map